export default __webpack_public_path__ + "static/media/logo-musaned.7eba4dfe.svg";